import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Linkedin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, SectionTag } from "./Reveal";
import { fetchTeam, toAbsolute } from "@/lib/api";

export default function Team() {
  const { t } = useLang();
  const [members, setMembers] = useState([]);

  useEffect(() => {
    fetchTeam().then((r) => setMembers(r.data)).catch(() => {});
  }, []);

  if (members.length === 0) return null;

  return (
    <section id="team" className="relative section-pad" data-testid="team-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl mb-14">
          <Reveal><SectionTag>{t.team.tag}</SectionTag></Reveal>
          <Reveal delay={0.05}>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mt-5 mb-4">{t.team.title}</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-slate-400 text-base sm:text-lg leading-relaxed">{t.team.subtitle}</p>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {members.map((m, i) => (
            <Reveal key={m.id} delay={(i % 4) * 0.08}>
              <motion.div whileHover={{ y: -6 }} className="group card-surface rounded-3xl overflow-hidden" data-testid={`team-member-${i}`}>
                <div className="relative aspect-[4/5] overflow-hidden">
                  <img src={toAbsolute(m.photo)} alt={m.name} loading="lazy" className="h-full w-full object-cover grayscale group-hover:grayscale-0 scale-105 group-hover:scale-110 transition-all duration-700" />
                  <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, transparent 45%, rgba(5,9,20,0.95))" }} />
                  <div className="absolute bottom-0 inset-x-0 p-5">
                    <h3 className="font-bold text-lg leading-tight">{m.name}</h3>
                    <p className="text-primary text-sm font-medium mt-1">{m.role}</p>
                  </div>
                  <span className="absolute top-4 end-4 h-9 w-9 rounded-full grid place-items-center opacity-0 group-hover:opacity-100 transition-opacity" style={{ background: "rgba(0,242,96,0.15)", backdropFilter: "blur(6px)" }}>
                    <Linkedin size={16} className="text-primary" />
                  </span>
                </div>
                {m.bio && <p className="px-5 py-4 text-sm text-slate-400 leading-relaxed" dir="auto">{m.bio}</p>}
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
